import React, {useRef} from 'react';

import {makeReactContext} from 'lib/makeReactContext';
import {EdgeIdToComputedEdgeData} from 'processes/graph-builder/flowchart-viz/FlowchartVizConstants';

type ReferencedEdgeIdToComputedEdgeData = React.MutableRefObject<EdgeIdToComputedEdgeData>;

const FlowchartCacheDataContext = makeReactContext<ReferencedEdgeIdToComputedEdgeData>(() => {
  throw new Error('Cannot use FlowchartCacheDataContext without a root');
}, 'FlowchartCacheDataContext');

export function useFlowchartCacheDataContext(): ReferencedEdgeIdToComputedEdgeData {
  return FlowchartCacheDataContext.useContext();
}

export default function FlowchartCacheDataProvider({children}: {children: React.ReactNode}): JSX.Element {
  const cacheRef = useRef<EdgeIdToComputedEdgeData>({});

  return <FlowchartCacheDataContext.Provider value={cacheRef}>{children}</FlowchartCacheDataContext.Provider>;
}
